import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface IAddButtonProps {
  handleClick: () => void;
  title: string;
}

// could be broken out into its own component for reuse later
const AddButton: React.FC<IAddButtonProps> = (props) => {
  return (
    <React.Fragment>
      <Tooltip title={props.title}>
        <IconButton onClick={props.handleClick}>
          <AddIcon />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
};

export default AddButton;
